import React from 'react';

function LoadingSpinner() {
  return (
    <div className="route-loading-spinner">
      <div className="route-spinner"></div>
    </div>
  );
}

export default LoadingSpinner;
